export default {
    meta: {
        title: '升级成功',
    },
};
